/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { EmptyTestimonial } from "./empty-testimonial";
import { TestimonialCarousel } from "./testimonial-carousel";
import { DefaultTestimonialDisplay } from "./default-testimonial";

const Testimonial = (props) => {
    const { component } = props;
    const { title, subtitle, testimonial_list = [] } = component || {};

    const moreThanTwoTestimonials = testimonial_list?.length > 2;

    const hasTestimonial = testimonial_list?.length > 0;

    return (
        <div className="testimonial-wrapper">
            <div className="testimonial-title">
                <p className="testimonial-title-paragraph">
                    <span className="title">{title}</span>
                    <span className="subtitle"> {subtitle}</span>
                </p>
            </div>
            <div className="testimonial-content">
                {moreThanTwoTestimonials ? (
                    <TestimonialCarousel testimonialList={testimonial_list} />
                ) : hasTestimonial ? (
                    <DefaultTestimonialDisplay testimonialList={testimonial_list} />
                ) : (
                    <EmptyTestimonial />
                )}
            </div>
        </div>
    );
};

Testimonial.displayName = "Testimonial";
export { Testimonial };
